import React, { useEffect } from 'react';
import useInputHelper from './inputHelper';
import { useUiTheme } from 'framework/uiTheme';
import {
  DefaultInputLayoutProps,
  DefaultInputPropTypes,
  InputEventProps,
  InputLayoutStateProps,
  MarginProps,
  ValidationLayoutProps,
} from './types';
import { SxProps } from '@mui/system';

export interface CheckboxLayoutProps
  extends
    DefaultInputLayoutProps<boolean>,
    ValidationLayoutProps,
    InputEventProps<object>,
    InputLayoutStateProps,
    MarginProps {
  fullWidth?: boolean;
  tooltip?: Nullable<string | React.ReactElement>;
  disableLabelClick?: boolean;
  sxCheckbox?: Nullable<SxProps>;
}

export type CheckboxLayoutType = ReactComponent<CheckboxLayoutProps>;

export interface CheckboxProps extends DefaultInputPropTypes<boolean> {
  fullWidth?: boolean;
  defaultValue?: boolean;
  disableLabelClick?: boolean;
  sxCheckbox?: Nullable<SxProps>;
}

const Checkbox = ({ isVisible = true, fullWidth = true, defaultValue = false, ...props }: CheckboxProps) => {
  const inputHelper = useInputHelper(props);
  const { CheckboxLayout } = useUiTheme<CheckboxLayoutType>();
  const value = inputHelper.getValue();

  useEffect(() => {
    if (typeof value !== 'boolean') {
      inputHelper.initializeValue(defaultValue as boolean);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return isVisible ? (
    <CheckboxLayout
      {...props}
      className={inputHelper.getClassName()}
      label={inputHelper.getLabel()}
      source={inputHelper.getSource()}
      onChangeCallback={inputHelper.getRawOnChangeCallback()}
      onBlurCallback={inputHelper.getValidationCallback()}
      onFocusCallback={inputHelper.getClearValidationCallback()}
      value={typeof value === 'boolean' ? value : defaultValue}
      isRequired={inputHelper.getIsRequired()}
      disabled={inputHelper.getIsDisabled()}
      errorMessages={inputHelper.getErrorMessages()}
      tooltip={inputHelper.getTooltip()}
    />
  ) : null;
};

export default Checkbox;
